<template>
  <v-text-field
    v-model="amount"
    :prefix="money && money.currency ? $options.filters.currencySymbol(money.currency): currencySymbol"
    :error-messages="errorMessages"
    :label="label"
    :disabled="disabled"
    :class="disabled ? 'text--disabled' : ''"
    outline
    @input="change"
  />
</template>

<script>
import Money from 'js-money'
import { mapGetters } from 'vuex'
import currencies from '@/../node_modules/js-money/lib/currency'

export default {
  name: 'MoneyInput',

  props: {
    value: {
      type: Object,
      default: null
    },

    label: {
      type: String,
      default: ''
    },

    errorMessages: {
      type: Array,
      default: () => []
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      money: this.value,
      amount: 0,
      moneyLoaded: false
    }
  },

  computed: {
    ...mapGetters(['currency', 'currencySymbol'])
  },

  watch: {
    value: function () {
      this.initMoneyInput()
    }
  },

  mounted () {
    this.initMoneyInput()
  },

  methods: {
    initMoneyInput () {
      if (this.value === null) {
        this.money = new Money(0, this.currency)
        this.amount = 0
        return
      }

      this.money = Money.fromInteger({
        amount: parseInt(this.value.amount),
        currency: this.value.currency || this.currency
      })

      this.amount = this.parse(this.money.toString())
    },

    change () {
      if (this.amount === '') {
        this.$emit('input', null)
        return
      }

      let currencyInfo = currencies[this.currency]
      // converting float value to integer money format
      let value = parseInt(parseFloat(this.amount).toFixed(currencyInfo.decimal_digits).toString().replace(/[,.]/g, ''))

      this.$emit('input', new Money(value, this.money.currency))
    },

    parse (value) {
      value = value.toString()
      if (value.indexOf('.') === -1) {
        return value
      }

      let cutFrom = value.length - 1

      do {
        if (value[cutFrom] === '0') {
          cutFrom--
        }
      } while (value[cutFrom] === '0')

      if (value[cutFrom] === '.') {
        cutFrom--
      }

      return value.substr(0, cutFrom + 1)
    }
  }
}
</script>
